import { ActionIcon, Menu } from '@mantine/core';
import { IconDots, IconFilter, IconSettings, IconTrash } from '@tabler/icons';
import { FC, useContext } from 'react';
import { TestS } from '../../../../TestS';
import { GoogleCalendarDto } from '../../../../Types/GoogleT';
import { ViolationContext } from '../../../../Service/Context/ViolationContext';
import { useJwtClaims } from '../../../../Service/Context/AuthContext';
import { LicenceS } from '../../../../Service/LicenceS';
import { openDeleteGoogleCalendarModal } from './DeleteGoogleCalendarModal';
import { openGoogleCalendarAdvancedConfigModal, openGoogleCalendarConfigModal } from './GoogleCalendarConfigModal';

interface Props {
  googleCalendar: GoogleCalendarDto;
  removeHandler: () => void;
  updateHandler: (patch: Partial<GoogleCalendarDto>) => void;
}

const GoogleCalendarActions: FC<Props> = ({ googleCalendar, removeHandler, updateHandler }) => {
  const { executeWithLicenceCheck } = useContext(ViolationContext);
  const { licence: userLicence } = useJwtClaims();
  const hasFlowLicence = LicenceS.hasSuitableLicence('FLOW', userLicence);

  return (
    <Menu shadow="md" width={175} transition="scale-y" position="bottom-end">
      <Menu.Target>
        <ActionIcon>
          <IconDots data-testid={TestS.Documents.List.Dropdown.OPEN} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          icon={<IconSettings size={16} />}
          onClick={() => openGoogleCalendarConfigModal(googleCalendar, updateHandler, executeWithLicenceCheck)}
        >
          Einstellungen
        </Menu.Item>
        {hasFlowLicence && (
          <>
            <Menu.Item
              disabled={!googleCalendar.write}
              icon={<IconFilter size={16} />}
              onClick={() => openGoogleCalendarAdvancedConfigModal(googleCalendar, updateHandler)}
            >
              Erweiterte Einstellungen
            </Menu.Item>
            {!googleCalendar.write && <Menu.Label>Aktiviere zuerst bookitup Events eintragen.</Menu.Label>}
          </>
        )}
        <Menu.Item
          color="red"
          icon={<IconTrash size={16} />}
          onClick={() => openDeleteGoogleCalendarModal(googleCalendar, removeHandler)}
        >
          Löschen
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

export default GoogleCalendarActions;
